// @flow
import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import SearchableDropDown from './SearchableDropDown';
import type { Suggestion } from './dropdown/constants';
import { ORG_LOGO_BASE_URL } from './dropdown/constants';

export const ALL_PRODUCTS_TEXT = 'All Products';

export type MarketplaceProductSelectionProps = {
    products: any,
    onSelect?: () => void,
    selectedId?: number,
    orgId?: number,
    allOptionText?: string
};

export class MarketplaceProductSelectionStandalone extends PureComponent<
    MarketplaceProductSelectionProps
> {
    static defaultProps = {
        selectedId: 0,
        onSelect: () => {},
        allOptionText: ALL_PRODUCTS_TEXT
    };

    getTransformedDataSet = () => {
        const { products, selectedId, orgId, allOptionText } = this.props;

        let selected = 0;

        // Because we are injecting the ALL option, we have to
        // handle pointing to the correct index of the data array
        // that is built below. The allOffset starts off assuming
        // nothing has been selected. Once something has been
        // selected, the allOffset is set to 1 to account for the
        // all option being injected before the rest of the passed
        // in options.
        let allOffset = 0;

        let allTeamsOption = {
            text: allOptionText,
            image: `${ORG_LOGO_BASE_URL}/${orgId}`,
            allOption: true
        };

        let data: Array<Suggestion> = [allTeamsOption];

        for (let i = 0; i < products.length; i++) {
            const { teamId, teamName, teamLogo } = products[i];

            if (teamId === selectedId) {
                selected = i;
                allOffset = 1;
            }

            data.push({
                id: teamId,
                text: teamName,
                image: teamLogo
            });
        }

        return {
            data,
            selected,
            allOffset
        };
    };

    render() {
        const { data, selected, allOffset } = this.getTransformedDataSet();
        return (
            <div className="fixed-width-dropdown">
                <SearchableDropDown
                    data={data}
                    selected={data[selected + allOffset]}
                    onSelect={this.props.onSelect}
                />
            </div>
        );
    }
}

const mapStateToProps = (state: any, ownProps: any) => {
    return {
        products: state.analytics.marketplaceProducts,
        orgId: state.app.loggedInUser.org_id
    };
};

export default connect(mapStateToProps)(MarketplaceProductSelectionStandalone);
